(() => {
  const ready = new WeakSet();
  const json = (id) => {
    try { return JSON.parse(document.getElementById(id)?.textContent || '{}'); } catch { return {}; }
  };
  const copy = () => ({ ...json('U4Copy'), ...json('U4GuidanceCopy') });
  const currentProduct = (item) => {
    const fresh = (json('U4Catalog').products || []).find(product => String(product.id) === String(item.id));
    return fresh ? { ...fresh, variantId: item.variantId } : { id: item.id, title: item.title, url: item.url, variants: [], missing: true };
  };
  const currentVariant = (item) => (item.variants || []).find(variant => String(variant.id) === String(item.variantId)) || (item.variants || []).find(variant => variant.available) || item.variants?.[0];
  const selectedUrl = (item) => {
    const variant = currentVariant(item);
    const url = new URL(item.url, location.origin);
    if (variant) url.searchParams.set('variant', variant.id);
    return url.pathname + url.search;
  };
  const node = (tag, value, className) => {
    const item = document.createElement(tag);
    if (value !== undefined) item.textContent = value;
    if (className) item.className = className;
    return item;
  };
  const startMap = (map) => {
    if (ready.has(map)) return;
    ready.add(map);
    const tabs = [...map.querySelectorAll('[role="tab"]')];
    const panels = [...map.querySelectorAll('[role="tabpanel"]')];
    const activate = (tab, focus) => {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        item.classList.toggle('is-active', active);
      });
      panels.forEach(panel => {
        const active = panel.id === tab.getAttribute('aria-controls');
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      map.dataset.activeZone = tab.dataset.zone || '';
      if (focus) tab.focus();
    };
    if (!tabs.length) return;
    map.classList.add('is-enhanced');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next], true);
      });
    });
    activate(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0], false);
  };
  let selected = [];
  try {
    const saved = JSON.parse(sessionStorage.getItem('u4wd-comparison') || '[]');
    selected = Array.isArray(saved) ? saved.filter(item => item.id && item.title && item.url).slice(0, 3) : [];
  } catch { selected = []; }
  const syncCompare = () => {
    selected = selected.map(currentProduct);
    document.querySelectorAll('[data-u4-compare]').forEach(button => {
      try {
        const product = JSON.parse(button.dataset.u4Compare);
        const index = selected.findIndex(item => String(item.id) === String(product.id));
        button.setAttribute('aria-pressed', String(index !== -1));
      } catch { button.disabled = true; }
    });
    const bar = document.querySelector('[data-u4-compare-bar]');
    if (bar) bar.hidden = selected.length === 0;
    const count = document.querySelector('[data-u4-compare-count]');
    if (count) count.textContent = selected.length + '/3 ' + (copy().count || '');
    try { sessionStorage.setItem('u4wd-comparison', JSON.stringify(selected)); } catch { }
  };
  const renderComparison = () => {
    const container = document.querySelector('[data-u4-compare-table]');
    if (!container) return;
    selected = selected.map(currentProduct);
    const labels = copy();
    if (!selected.length) { container.replaceChildren(node('p', labels.compare_empty)); return; }
    const table = node('table');
    table.append(node('caption', document.getElementById('U4CompareTitle')?.textContent || '', 'visually-hidden'));
    const head = node('thead');
    const first = node('tr');
    first.append(node('th', ''));
    selected.forEach(product => {
      const th = node('th'); th.scope = 'col';
      if (product.image) {
        const image = node('img'); image.src = product.image; image.alt = ''; image.width = 150; image.height = 130; th.append(image);
      }
      const link = node('a', product.title); link.href = selectedUrl(product); th.append(link);
      const variant = currentVariant(product);
      const sku = node('small', labels.sku + ': ' + (variant?.sku || labels.unknown));
      th.append(sku);
      if (product.variants.length > 1) {
        const optionLabel = node('label', product.optionNames?.join(' / ') || labels.option);
        const select = node('select'); select.dataset.u4CompareVariant = product.id;
        select.setAttribute('aria-label', (product.optionNames?.join(' / ') || labels.option) + ' · ' + product.title);
        product.variants.forEach(item => {
          const option = node('option', item.title + (!item.available ? ' · ' + labels.unavailable : ''));
          option.value = item.id; option.selected = String(item.id) === String(variant?.id); select.append(option);
        });
        optionLabel.append(select); th.append(optionLabel);
      }
      const remove = node('button', labels.remove); remove.type = 'button';
      remove.setAttribute('aria-label', labels.remove + ' ' + product.title);
      remove.dataset.u4CompareRemove = product.id; th.append(remove); first.append(th);
    });
    head.append(first);
    const body = node('tbody');
    const definitions = [
      { key: 'price', value: product => ({ text: currentVariant(product)?.money || labels.unknown }) },
      { key: 'availability', value: product => ({ text: labels[currentVariant(product)?.stock] || labels.unknown }) },
      { key: 'unit', value: product => ({ text: product.unit || labels.unknown }) },
      { key: 'beam', value: product => ({ text: product.beam || labels.unknown, detail: labels.colour + ': ' + (product.colour || labels.unknown) }) },
      { key: 'size', value: product => ({ text: product.size || labels.unknown, detail: labels.verify_dimensions }) },
      { key: 'harness', value: product => ({ text: product.harness === true ? labels.listed_harness : labels.unknown_harness }) },
      { key: 'power', value: product => ({ text: product.power || labels.unknown, detail: labels.power_basis }) },
      { key: 'output', value: () => ({ text: labels.output_unverified, detail: labels.measurement_unknown }) },
      { key: 'dimensions', always: true, value: () => ({ text: labels.unknown, detail: labels.fitment_unknown }) },
      { key: 'source', always: true, value: product => ({ text: labels.listed_record, link: product.url + '#product-details' }) }
    ];
    const differencesControl = document.querySelector('[data-u4-compare-differences]');
    if (differencesControl) {
      differencesControl.disabled = selected.length < 2;
      if (selected.length < 2) differencesControl.checked = false;
    }
    const differences = differencesControl?.checked;
    definitions.forEach(definition => {
      const values = selected.map(definition.value);
      const different = new Set(values.map(value => JSON.stringify([value.text, value.detail]))).size > 1;
      if (differences && !different && !definition.always) return;
      const row = node('tr'); if (different) row.classList.add('is-different');
      const heading = node('th', labels[definition.key] || definition.key); heading.scope = 'row'; row.append(heading);
      values.forEach(value => {
        const cell = node('td');
        if (value.link) { const link = node('a', value.text); link.href = value.link; cell.append(link); }
        else cell.append(node('span', value.text));
        if (value.detail) cell.append(node('small', value.detail));
        row.append(cell);
      });
      body.append(row);
    });
    table.append(head, body); container.replaceChildren(table);
  };
  const startSticky = (bar) => {
    if (ready.has(bar)) return;
    ready.add(bar);
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    const primary = main?.querySelector('.product-form__submit');
    if (!primary) return;
    const measure = () => {
      const height = bar.getBoundingClientRect().height;
      if (height) document.documentElement.style.setProperty('--u4-sticky-height', height + 'px');
    };
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(bar);
    measure();
    const action = bar.querySelector('button');
    const label = bar.querySelector('[data-u4-sticky-price]');
    const sync = () => {
      const current = main.querySelector('.product-form__submit');
      const id = main.querySelector('product-form input[name="id"]');
      action.disabled = !id?.value || current?.disabled || current?.getAttribute('aria-disabled') === 'true';
      action.textContent = current?.querySelector('span')?.textContent?.trim() || current?.textContent?.trim() || '';
      const price = main.querySelector('.price-item--sale')?.closest('.price--on-sale') ? main.querySelector('.price-item--sale') : main.querySelector('.price-item--regular');
      if (price && label) label.textContent = price.textContent.trim();
    };
    action.addEventListener('click', () => {
      sync();
      if (!action.disabled) main.querySelector('.product-form__submit')?.click();
    });
    new MutationObserver(sync).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
    new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }, { threshold: 0 }).observe(primary);
    sync();
  };
  const start = (root = document) => {
    root.querySelectorAll('[data-na-map]').forEach(startMap);
    root.querySelectorAll('[data-u4-sticky]').forEach(startSticky);
    syncCompare();
  };
  document.addEventListener('click', event => {
    const compare = event.target.closest('[data-u4-compare]');
    if (compare) {
      try {
        const product = JSON.parse(compare.dataset.u4Compare);
        const index = selected.findIndex(item => String(item.id) === String(product.id));
        if (index >= 0) selected.splice(index, 1);
        else if (selected.length < 3) selected.push(currentProduct(product));
        else { const count = document.querySelector('[data-u4-compare-count]'); if (count) count.textContent = copy().limit; return; }
        syncCompare();
      } catch { }
    }
    if (event.target.closest('[data-u4-compare-open]')) { renderComparison(); document.getElementById('U4Compare')?.showModal(); }
    if (event.target.closest('[data-u4-compare-close]')) document.getElementById('U4Compare')?.close();
    if (event.target.closest('[data-u4-compare-clear]')) { selected = []; syncCompare(); }
    const remove = event.target.closest('[data-u4-compare-remove]');
    if (remove) {
      selected = selected.filter(item => String(item.id) !== remove.dataset.u4CompareRemove);
      syncCompare();
      if (selected.length) { renderComparison(); document.querySelector('[data-u4-compare-remove]')?.focus(); } else document.getElementById('U4Compare')?.close();
    }
    if (event.target.closest('.u4-mobile-menu a')) event.target.closest('.u4-mobile-menu').open = false;
    document.querySelectorAll('.u4-shop-menu[open], .u4-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.u4-shop-menu[open], .u4-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('change', event => {
    const selector = event.target.closest('[data-u4-compare-variant]');
    if (selector) {
      selected = selected.map(product => String(product.id) === selector.dataset.u4CompareVariant ? { ...product, variantId: selector.value } : product);
      syncCompare(); renderComparison();
      document.querySelector('[data-u4-compare-variant="' + selector.dataset.u4CompareVariant + '"]')?.focus();
    }
    if (event.target.matches('[data-u4-compare-differences]')) renderComparison();
  });
  document.addEventListener('u4:comparison-refresh', syncCompare);
  document.addEventListener('u4:catalog-variant', event => {
    selected = selected.map(product => String(product.id) === String(event.detail.id) ? { ...product, variantId: event.detail.variantId } : product);
    syncCompare();
  });
  const updateCartCount = cart => {
    if (!Number.isInteger(cart?.item_count)) return false;
    document.querySelectorAll('[data-u4-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    return true;
  };
  const syncCart = async event => {
    if (updateCartCount(event?.cartData || event?.detail?.cartData || event?.detail)) return;
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      updateCartCount(cart);
    } catch { }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, syncCart);
  document.addEventListener('blaze:cart-updated', syncCart);
  document.addEventListener('shopify:section:load', event => start(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
})();

// Dismiss only the retired reward wheel in this theme; keep other forms and tracking.
(() => {
  if (!document.body.classList.contains('u4wd-november')) return;
  const retiredId = 'omnisend-form-6a0730cf9a6498d620158ed5';
  const dismissed = new WeakSet();
  const dismissRetiredReward = () => {
    const form = document.getElementById(retiredId);
    if (!form || dismissed.has(form)) return;
    const close = form.querySelector('button[aria-label="Close"], [role="button"][aria-label="Close"]');
    if (!close) return;
    dismissed.add(form);
    requestAnimationFrame(() => {
      if (!form.isConnected) return;
      close.click();
      form.setAttribute('aria-hidden', 'true');
      form.setAttribute('inert', '');
    });
  };
  new MutationObserver(dismissRetiredReward).observe(document.body, { childList: true, subtree: true });
  dismissRetiredReward();
})();
